function togglePartners(event) {
    if (dragging) return;

    var target = event.target.closest(".partners-listing .tab-links a");
    if (target) {
        event.preventDefault();
        event.stopPropagation();

        document.querySelectorAll(".partners-listing .tab-links a:not([data-category='" + target.getAttribute("data-category") + "'])").forEach(function (el) {
            el.classList.remove("active");
        });
        target.classList.add("active");

        document.querySelectorAll(".partners-listing .tab:not([data-category='" + target.getAttribute("data-category") + "'])").forEach(function (el) {
            el.classList.remove("active");
        });
        document.querySelector(".partners-listing .tab[data-category='" + target.getAttribute("data-category") + "']").classList.add("active");
    }
}

document.addEventListener("click", togglePartners);
document.addEventListener("touchend", togglePartners);